module.exports = __webpack_public_path__ + "img/CosmicBrownie.15ba8f64.png";